import type { ClassValue } from 'clsx'
import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Le doc-id final (afpshortid) n'a pas de longueur fixe : `+` plutôt qu'un
// plancher arbitraire (le préfixe `.doc-` suffit à éviter les faux positifs).
export const UNO_REGEX =
  /newsml(?:mmd)?\.afp\.com\.\d{8}T\d{6}Z\.doc-[a-z0-9]+/g

export const uniqueBy = <V>(arr: V[], fn: (item: V) => string) => {
  const identifiers = new Set()
  return arr.reduce<V[]>((acc, item) => {
    const identifier = fn(item)
    if (identifiers.has(identifier)) return acc
    identifiers.add(identifier)
    acc.push(item)
    return acc
  }, [])
}

export function moveArrayItem<T>(
  array: T[],
  fromIndex: number,
  to: number | 'left' | 'right'
): T[] {
  const newArray = [...array]

  let toIndex
  if (to === 'left') {
    toIndex = Math.max(0, fromIndex - 1)
  } else if (to === 'right') {
    toIndex = Math.min(array.length - 1, fromIndex + 1)
  } else if (typeof to === 'number') {
    toIndex = Math.max(0, Math.min(array.length - 1, to))
  } else {
    throw new Error("Direction invalide. Utilisez 'left', 'right' ou un nombre")
  }

  const [element] = newArray.splice(fromIndex, 1)

  if (element !== undefined) {
    newArray.splice(toIndex, 0, element)
  }

  return newArray
}
